import React from "react";
import Nav from "react-bootstrap/Nav";
import { useAppContext } from "../libs/contextLib";
import "./Menu.css";

export default function Top() {
  const { userProfile } = useAppContext();
  return (
    <div className="Home">
      <h1 id="page_title">テストサイト</h1>
      <div className="container">
        <div id="sub_page">
          <div id="mypage" className="top">
              <section>
                <div className="inner">
                  <ul>
                    <li>
                      <Nav.Link href="signup?opt=1&mt=1">申込画面（正会員）</Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="signup?opt=2&mt=4">申込画面（准会員）</Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="signup?opt=10&mt=14">申込画面（学生会員）</Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="/login?m=rm">正会員用マイページ</Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="/login?m=am">准会員用マイページ</Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="/login?m=ad">管理画面</Nav.Link>
                    </li>
                  </ul>
                </div>
              </section>
          </div>
        </div>
      </div>
      
    </div>
  );
}
